import { useEnableV3SearchAPI } from "../../toggles";
import { SearchDropdownWrapper } from "./SearchDropdownWrapper";
import { GlobalSearch } from "../GlobalSearch";
import { useEnableGlobalSearchNext } from "../../toggles/useEnableGlobalSearchNext";
import { GlobalSearchNext } from "../GlobalSearchNext/GlobalSearchNext";
import { GlobalSearchWithSDO } from "../GlobalSearchWithSDO/GlobalSearchWithSDO";
import { useEnableDataObjects } from "../../hooks/useEnableDataObjects";

const SearchSwitch = () => {
  const isEnableV3SearchAPI = useEnableV3SearchAPI();
  const shouldUseGlobalSearchNext = useEnableGlobalSearchNext();
  const isDataObjectsEnabled = useEnableDataObjects();

  const isSDOGlobalSearch = shouldUseGlobalSearchNext && isDataObjectsEnabled;
  if (isSDOGlobalSearch) return <GlobalSearchWithSDO />;
  if (shouldUseGlobalSearchNext) return <GlobalSearchNext />;
  if (isEnableV3SearchAPI) return <GlobalSearch />;
  return <SearchDropdownWrapper />;
};

export { SearchSwitch as SearchDropdown };
